import React, { useCallback } from "react"
import currency from "currency.js"


interface InputCurrencyProps {
    className?: string,
    style?: any,
    currencyconfig: {
        locale: "pt-BR",
        currencyCode: "BRL",
        currencyDisplay?: "symbol",
        useGrouping?: true,
        minimumFractionDigits?: number
    },
    customInput?: any
    propscustominput?:any
    name?: string,
    id: any,
    onChange: any
    value: any
    disabled?: boolean
}

const VALID_FIRST = /^[1-9]{1}$/;
const VALID_NEXT = /^[0-9]{1}$/;
const DELETE_KEY_CODE = 8;
const max = Number.MAX_SAFE_INTEGER;
const CurrencyInput = (props: InputCurrencyProps) => {
    const { className, currencyconfig, customInput, id, name, onChange, style, value,propscustominput,disabled } = props;
    const fakeChangeEvent = {
        target: {
            type: "number",
            name,
            id,
            value
        },
        type:"custom"
    };
    var valueInCents = currency(value).intValue;
    const valueAbsTrunc = Math.trunc(Math.abs(valueInCents));

    if (valueInCents !== valueAbsTrunc || !Number.isFinite(valueInCents) || Number.isNaN(valueInCents)) {
        throw new Error("invalid value property");
    }

    const handleKeyDown = (ev:any)=> {
        const {key,keyCode } = ev;
        if (valueInCents === 0 && !VALID_FIRST.test(key) || valueInCents !== 0 && !VALID_NEXT.test(key) && keyCode !== DELETE_KEY_CODE) {
            return;
        }

        const valueString = valueInCents.toString();
        let nextValue;
    
        if (keyCode !== DELETE_KEY_CODE) {
          const nextValueString = valueInCents === 0 ? key : "".concat(valueString).concat(key);
          nextValue = Number.parseInt(nextValueString, 10);
        } else {
          const nextValueString = valueString.slice(0, -1);
          nextValue = nextValueString === "" ? 0 : Number.parseInt(nextValueString, 10);
        }
    
        if (nextValue > max) {
          return;
        } // Enforce our division with currency to prevent rounding errors
    
        valueInCents = currency(nextValue / 100).value;
        fakeChangeEvent.target.value = valueInCents;
        onChange(fakeChangeEvent);    
    };

    const handleChange = useCallback(()=>{},[])
    const {
        locale,
        currencyCode,
        currencyDisplay,
        useGrouping,
        minimumFractionDigits
      } = currencyconfig;
    const valueDisplay = currency(valueInCents / 100).value.toLocaleString(locale,{
        style:"currency",
        currency:currencyCode,
        currencyDisplay:currencyDisplay,
        useGrouping:useGrouping,
        minimumFractionDigits:minimumFractionDigits,
    });

    const inputProps = {
        "data-testid": "currency-input",
        className: className,
        inputMode: "numeric",
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        style: style,
        value: valueDisplay,
        disabled: disabled,
    }; 
    
    if (customInput) {
        const customProps = {...props,...propscustominput, ...inputProps};
        delete customProps.customInput;
        const CustomInput = customInput;
        return React.createElement(CustomInput, customProps)
    }

    return React.createElement("input", inputProps)

}

export default CurrencyInput